import "swiper/css/bundle";
import React from 'react';

// import required modules
import { sanitizeData } from '@framework/utils/app-util';

const CategoryColumPanel = ({ data, columnCount }: any) => {
   // const css = { maxWidth: '100%', height: 'auto' }
   return (
      <>
         {data && data[columnCount + "columnheading"]?.length > 0 && (
            <>
               {data[columnCount + "columnheading"] && data[columnCount + "columnheading"]?.length > 0 && sanitizeData(data[columnCount + "columnheading"])?.map((heading: any, hid: number) => (
                  <>
                     {(heading[columnCount + "columnheading_subtitle"] != '' || heading[columnCount + "columnheading_title"] != '') && (
                        <div className='py-3'>
                           <div className='flex flex-col px-0 sm:px-4'>
                              <div className="flex flex-col justify-center px-4 sm:px-4 lg:px-0" key={`${hid}-category-hid-${columnCount}`}>
                                 {heading[columnCount + "columnheading_subtitle"] != '' &&
                                    <h4 className="font-light tracking-tight text-center text-gray-400 text-md sm:text-md">
                                       {heading[columnCount + "columnheading_subtitle"]}
                                    </h4>
                                 }
                                 {heading[columnCount + "columnheading_title"] != '' &&
                                    <h2 className="mt-0 mb-2 text-xl font-bold tracking-tight text-center text-gray-900 sm:mb-0 sm:mt-2 heading sm:text-3xl">
                                       {heading[columnCount + "columnheading_title"]}
                                    </h2>
                                 }
                              </div>
                           </div>
                        </div>
                     )}
                  </>
               ))}
            </>
         )}
      </>
   )
}

export default CategoryColumPanel;